import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  &:not(:focus):not(:active) {\n    clip: rect(0 0 0 0);\n    clip-path: inset(50%);\n    height: 1px;\n    overflow: hidden;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import styled, { css } from "styled-components";
import Text from "./Text";
export var cssVisuallyHidden = css(_templateObject());
var VisuallyHidden = styled(Text).attrs(function(param) {
    var _as = param.as, as = _as === void 0 ? "span" : _as;
    return {
        as: as
    };
}).withConfig({
    componentId: "sc-c1951e42-0"
})(_templateObject1(), cssVisuallyHidden);
export default VisuallyHidden;
